import React from 'react'
import './Preview.scss'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import Property from '@engine/property'
import { Loading } from '@components/common'
import {
  PropertySettings,
  SummaryReport,
  PropertyRentCompT1,
  PropertyRentCompT2,
  PropertyRentCompT3,
  PropertyRentCompT4,
  PropertyRentCompT5,
  PropertyRentCompT6,
  PropertySalesComp,
  PropertySalesCompS2,
  PropertyStudentHousingCompSH1,
  PopUpDialog,
  BarChartsContainer,
  SelectSourceForUnitMixDialog
} from '@components/custom'
import Backdrop from '@material-ui/core/Backdrop'
import SaveProjectDialog from '../../components/custom/SaveProjectDialog/SaveProjectDialog'
import Snackbar from '@material-ui/core/Snackbar'
import { RENT_COMPARABLES, SALES_COMPARABLES, SH_COMPARABLES } from '@engine/dependencies/constants'
import moment from 'moment'
import sanitizeHtml from 'sanitize-html'

export class Preview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      snackbarFlag: false,
      saveProjectDialog: false,
      previewPageFullView: false,
      deleteProperty: { 'name': 'NA' },
      selectSourceDialog: false,
      unitMixSources: [],
      isPropertyExists: false
    }
    this.forceTimeout = null
    if (props.projectName) {
      // eslint-disable-next-line
      window._mtm.push({ 'event': 'previewProject', 'projectName': props.projectName, 'previewAction': 'by upload xlsx file' })
    }
  }

  componentDidUpdate = prevProps => {
    if (this.props.selectedProjectId && prevProps.selectedProjectId !== this.props.selectedProjectId) {
      this.props.history.push(`/preview/${this.props.selectedProjectId}`)
    }
    if (prevProps.status !== this.props.status) {
      this.setState({
        snackbarFlag: this.props.status === 'saved' || this.props.status === 'updated' || this.props.status === 'property'
      })
    }

    if (prevProps.isListRefreshed !== this.props.isListRefreshed && this.props.isListRefreshed) {
      this.setState({ snackbarFlag: this.props.isListRefreshed })
    }
    if (prevProps.propertySearchData !== this.props.propertySearchData) {
      const unitMixSourcesData = [...new Set(this.props.propertySearchData?.omniviewpropertyrent?.map(item => item.source))]
      const unitMixSources = []
      if (unitMixSourcesData.length) {
        unitMixSourcesData.forEach(key => {
          const pDataObj = this.props.propertySearchData?.omniviewpropertyrent?.find(
            pdata => pdata.source === key
          )
          unitMixSources.push({ key, value: `${key} - Last modified ${moment(pDataObj.date, 'YYYY-MM-DD').format('MM/DD/YYYY')}` })
        })
      }

      if (this.props.propertySearchData) {
        const propertyIdList = this.props.propertyInfo.reduce((prev, cur) => prev.concat(cur.propertySFId), [])
        if (propertyIdList?.includes(this.props.propertySearchData?.omniViewPropertyId)) {
          this.setState({ selectSourceDialog: true, unitMixSources, isPropertyExists: true })
        } else {
          this.setState({ selectSourceDialog: true, unitMixSources, isPropertyExists: false })
        }
      }
    }
  }

  componentDidMount = () => {
    const { propertyInfo, getProject, match: { params }, history } = this.props
    if (params?.projectId) {
      getProject(params.projectId)
    } else if (propertyInfo?.length < 2) {
      history.push('/comps')
    }
    // Hack to force update of refs in the case of browser refresh
    this.forceTimeout = setTimeout(() => this.forceUpdate(), 1)

    window.onbeforeunload = e => {
      e.returnValue = 'Changes you made may not be saved..'
    }

    window.onpopstate = e => {
      e.preventDefault()
      if (this.props.history.location.pathname.split('/')[2] === undefined) {
        this.props.isPopupDialogOpen({ isDialogOpen: true, dialogType: 'save' })
      } else if (this.props.history.location.pathname.split('/')[2] !== undefined && this.props.resetflag) {
        this.props.isPopupDialogOpen({ isDialogOpen: true, dialogType: 'save' })
      } else {
        this.props.clearComps()
        this.props.history.push('/comps')
      }
    }
  }

  handleCloseSnackbar = () => {
    this.setState({
      snackbarFlag: false
    })
  }

  onDiscard = () => {
    this.props.clearComps()
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
    this.props.history.push('/comps')
  }

  onDelete = () => {
    this.props.deleteProperty({ deleteProperty: this.state.deleteProperty })
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
    this.setState({ deleteProperty: { 'name': 'NA' } })
  }

  downloadPdfHandler = () => {
    const { downloadPdf } = this.props
    downloadPdf()
  }

  handleDeleteClick = property => {
    this.setState({ deleteProperty: property })
    this.props.isPopupDialogOpen({ isDialogOpen: true, dialogType: 'delete' })
  }

  componentWillUnmount() {
    clearTimeout(this.forceTimeout)
    window.onbeforeunload = null
  }

  toggleDiscardDialog = () => {
    this.props.isPopupDialogOpen({ isDialogOpen: true, dialogType: 'discard' })
  }

  refreshListInfo = selectedRefreshOption => {
    this.props.refreshListInfo(selectedRefreshOption)
  }

  cancelDialog = () => {
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
  }

  resetDialog = () => {
    this.props.isPopupDialogOpen({ isDialogOpen: true, dialogType: 'reset' })
  }

  handleResetConfirmation = () => {
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
    this.props.resetComps()
  }

  cancelDeleteDialog = () => {
    this.setState({ deleteProperty: { 'name': 'NA' } })
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
  }

  handleSaveProject = () => {
    this.props.isPopupDialogOpen({ isDialogOpen: false, dialogType: '' })
    this.handleSaveProjectDialog('open')
  }

  getPopupInformation = deletePropertyName => ({
    discard: {
      title: 'Discard?',
      cancelMessage: 'CANCEL',
      confirmMessage: 'DISCARD',
      popUpDialogmessage:
        'If you exit this window, your progress will not be saved.',
      canceleDialog: this.cancelDialog,
      discardDialog: this.onDiscard
    },
    delete: {
      title: 'Delete?',
      cancelMessage: 'CANCEL',
      confirmMessage: 'DELETE',
      popUpDialogmessage: `Are you sure you want to delete the Property "${deletePropertyName}"?`,
      canceleDialog: this.cancelDeleteDialog,
      discardDialog: this.onDelete
    },
    reset: {
      title: 'Reset?',
      cancelMessage: 'CANCEL',
      confirmMessage: 'RESET',
      popUpDialogmessage:
        'Please confirm whether you want to reset to default view',
      canceleDialog: this.cancelDialog,
      discardDialog: this.handleResetConfirmation
    },
    save: {
      title: 'Save?',
      saveMessage: 'YES',
      cancelMessage: 'NO',
      confirmMessage: 'CANCEL',
      popUpDialogmessage: 'Do you want to save the Project?',
      saveDialog: this.handleSaveProject,
      canceleDialog: this.onDiscard,
      discardDialog: this.cancelDialog
    }
  })

  loadPreviewFullScreen = () => {
    this.setState({ previewPageFullView: !this.state.previewPageFullView })
  }

  gotoPropertyPreview = type => {
    const ignoreWhenList = ['rentCompsT6', 'salesCompsT2']
    if (ignoreWhenList.includes(this.props.templateName)) {
      return
    }
    if (this.props.templateName === 'salesComps' && type !== 'barcharts') {
      document
        .getElementById(`#property_${type}`)
        .scrollIntoView({ block: 'end' })
    } else {
      document
        .getElementById(`#property_${type}`)
        .scrollIntoView({ block: 'start', inline: 'end' })
    }
  }

  getProperties = propertyName => {
    this.props.getProperties(propertyName)
  }

  getPropertyInfo = omniViewPropertyId => {
    this.props.getPropertyInfo(omniViewPropertyId)
  }

  getPropertyInfoByName = propertyIndex => {
    const infoObject = this.props.propertyInfo[propertyIndex]
    if (infoObject && infoObject.name !== 'NA') {
      const {
        comparableData,
        chartData,
        propertyData,
        signedUrl,
        hideUnitMixTotal,
        unitMixDisclaimerData
      } = infoObject

      return {
        comparableData: JSON.parse(sanitizeHtml(JSON.stringify(comparableData))),
        chartData: JSON.parse(sanitizeHtml(JSON.stringify(chartData))),
        propertyData: JSON.parse(JSON.stringify(propertyData)),
        signedUrl,
        hideUnitMixTotal,
        unitMixDisclaimerData
      }
    }

    return {}
  }

  handleSaveProjectDialog = (actionType, saveProjectObj) => {
    if (actionType === 'open') {
      this.props.getCompsOffices()
      this.setState({ saveProjectDialog: true })
    } else if (actionType === 'cancel') {
      this.setState({ saveProjectDialog: false })
    } else if (actionType === 'savedownload' && !this.props.selectedProjectId) {
      this.props.saveCompsProject({ ...saveProjectObj, saveType: actionType })
      this.setState({ saveProjectDialog: false })
    } else if (actionType === 'savedownload' && this.props.selectedProjectId) {
      this.props.updateCompsProject({ ...saveProjectObj, saveType: actionType })
      this.setState({ saveProjectDialog: false })
    } else if (actionType === 'save' && !this.props.selectedProjectId) {
      this.props.saveCompsProject({ ...saveProjectObj, saveType: actionType })
      this.setState({ saveProjectDialog: false })
    } else if (actionType === 'save' && this.props.selectedProjectId) {
      this.props.updateCompsProject({ ...saveProjectObj, saveType: actionType })
      this.setState({ saveProjectDialog: false })
    }
  }

  handleSourceDialog = (type, value) => {
    this.setState({ selectSourceDialog: false, unitMixSources: [], isPropertyExists: false })
    if (type === 'add') {
      this.props.getPropertyInfoBySource(value)
    }
  }


  // eslint-disable-next-line complexity
  render() {
    const {
      templateName,
      resetflag,
      propertyInfo,
      projectName,
      reArrangeComps,
      toggleSettings,
      barChartSettings: { isFloorPlan, isSummaryBarCharts },
      toggleSettings: { hasBranding, hasSourceNotes, hasUnitMix, hasPageTitle, templateType },
      barChartData,
      fpBarChartData,
      fpSummaryData,
      isDialogOpen,
      dialogType,
      getoffices,
      data
    } = this.props

    const {
      deleteProperty
    } = this.state
    const { getPopupInformation, resetDialog } = this
    const compsList =
      propertyInfo && propertyInfo.filter(obj => obj.propertyType !== 'NA')
    const properties = compsList.filter(
      property =>
        property.propertyType !== 'NA' &&
        !property.propertyType.toString().includes('S') &&
        !property.propertyType.toString().includes('s')
    )
    const propertyInfoResized = [...propertyInfo].filter(obj => obj.propertyType !== 'NA')

    if (templateType === 'T5' && (propertyInfoResized.length % 4 !== 0)) {
      const emptyProperty = 4 - (propertyInfoResized.length % 4)
      for (let i = 0; i < emptyProperty; i += 1) {
        propertyInfoResized.push({ propertyType: propertyInfoResized.length })
      }
    }

    const subject = compsList.filter(
      property => property.propertyType.toString().includes('S') || property.propertyType.toString().includes('s')
    )

    const propertyNameList = compsList.reduce((prev, cur) => prev.concat(cur.name.toUpperCase()), [])

    const { downloading, saving, loading, updating, listRefresh, editFeature, donutChartThemeColors, match } = this.props
    const headerForPagesInT3 = []
    propertyInfo.forEach((property, index) => {
      if (index % 2 === 0) {
        headerForPagesInT3.push(property.propertyType)
      }
    })

    const getSnackBarMessage = () => {
      let snackBarMessage = ''

      if (this.props.isListRefreshed) {
        return 'List Refreshed successfully!'
      }

      if (this.props.status) {
        snackBarMessage = this.props.status === 'property' ? 'Property added successfully' : `Project ${this.props.status} sucessfully!`
      }

      return snackBarMessage
    }

    return (
      <React.Fragment>
        <Loading isLoading={loading}>
          <React.Fragment>
            {templateName &&
              <div data-testid="preview" className="preview-page">
                {compsList && (
                  <PropertySettings
                    propertyData={compsList}
                    projectName={projectName}
                    toggleDiscardDialog={this.toggleDiscardDialog}
                    refreshListInfo={this.refreshListInfo}
                    downloadPDF={this.downloadPdfHandler}
                    handleDeleteClick={this.handleDeleteClick}
                    loadPreviewFullScreen={this.loadPreviewFullScreen}
                    previewPageFullView={this.state.previewPageFullView}
                    gotoPropertyPreview={this.gotoPropertyPreview}
                    subject={subject}
                    properties={properties}
                    reArrangeComps={reArrangeComps}
                    resetflag={resetflag}
                    resetComps={resetDialog}
                    barChartData={barChartData}
                    handleSaveProjectDialog={this.handleSaveProjectDialog}
                    donutChartThemeColors={donutChartThemeColors}
                    match={match}
                    getProperties={this.getProperties}
                    propertiesData={data}
                    getPropertyInfo={this.getPropertyInfo}
                    closeSourceDialog={this.state.selectSourceDialog}
                  />
                )}
                <div
                  className={
                    this.state.previewPageFullView
                      ? 'preview-fullscreen'
                      : 'preview-left'
                  }
                >
                  {templateType !== 'T6' && templateType !== 'S2' &&
                    <SummaryReport
                      summarydata={propertyInfo}
                      hasBranding={hasBranding}
                      templateName={templateName}
                      hasPageTitle={hasPageTitle}
                    />
                  }
                  {templateType === 'T6' && (
                    <PropertyRentCompT6
                      summarydata={propertyInfo}
                      hasBranding={hasBranding}
                      hasPageTitle={hasPageTitle}
                      toggleSettings={toggleSettings}
                      editFeature={editFeature}
                    />
                  )}
                  {templateType === 'S2' && (
                    <PropertySalesCompS2
                      summarydata={propertyInfo}
                      hasBranding={hasBranding}
                      hasPageTitle={hasPageTitle}
                      toggleSettings={toggleSettings}
                      editFeature={editFeature}
                    />
                  )}
                  {templateName.includes(RENT_COMPARABLES) &&
                    propertyInfoResized &&
                    propertyInfoResized.map((summaryProp, index) => {
                      if (summaryProp.propertyType !== 'NA') {
                        return (
                          <React.Fragment key={index}>
                            {templateType === 'T1' && (
                              <PropertyRentCompT1
                                key={index}
                                templateName={templateName}
                                propertyType={summaryProp.propertyType}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                            {templateType === 'T2' && (
                              <PropertyRentCompT2
                                key={index}
                                templateName={templateName}
                                propertyType={summaryProp.propertyType}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                            {templateType === 'T3' && (
                              <PropertyRentCompT3
                                key={index}
                                templateName={templateName}
                                propertyType={summaryProp.propertyType}
                                headerForPagesInT3={headerForPagesInT3}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                            {templateType === 'T4' && (
                              <PropertyRentCompT4
                                key={index}
                                templateName={templateName}
                                propertyType={summaryProp.propertyType}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                            {templateType === 'T5' && (
                              <PropertyRentCompT5
                                key={index}
                                propertyType={summaryProp.propertyType}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                          </React.Fragment>
                        )
                      }

                      return null
                    })}

                  {templateName.includes(SH_COMPARABLES) &&
                    propertyInfoResized &&
                    propertyInfoResized.map((summaryProp, index) => {
                      if (summaryProp.propertyType !== 'NA') {
                        return (
                          <React.Fragment key={index}>
                            {templateType === 'SH1' && (
                              <PropertyStudentHousingCompSH1
                                key={index}
                                templateName={templateName}
                                propertyType={summaryProp.propertyType}
                                toggleSettings={toggleSettings}
                                editFeature={editFeature}
                                propertyInfoData={this.getPropertyInfoByName(index)}
                                donutChartThemeColors={donutChartThemeColors}
                                propertyNameList={propertyNameList}
                              />
                            )}
                          </React.Fragment>
                        )
                      }

                      return null
                    })}

                  {templateName === SALES_COMPARABLES && (
                    <PropertySalesComp
                      templateName={templateName}
                      hasSourceNotes={hasSourceNotes}
                      hasBranding={hasBranding}
                      hasPageTitle={hasPageTitle}
                      hasUnitMix={hasUnitMix}
                      propertyInfoData={propertyInfo}
                      templateType={templateType}
                      editFeature={editFeature}
                      propertyNameList={propertyNameList}
                    />
                  )}
                  {templateType !== 'T6' && templateType !== 'S2' && isSummaryBarCharts && barChartData.length > 0 && (
                    <BarChartsContainer
                      toggleSettings={toggleSettings}
                      barChartData={barChartData}
                    />
                  )}
                  {templateType !== 'T6' && templateType !== 'S2' && !templateName.includes(SALES_COMPARABLES) && isFloorPlan && fpSummaryData && fpBarChartData && (
                    <BarChartsContainer
                      toggleSettings={toggleSettings}
                      barChartData={fpBarChartData}
                      fpSummaryData={fpSummaryData}
                    />
                  )}
                </div>
                {isDialogOpen && dialogType && (
                  <PopUpDialog
                    title={getPopupInformation()[dialogType].title}
                    saveMessage={getPopupInformation()[dialogType].saveMessage}
                    cancelMessage={getPopupInformation()[dialogType].cancelMessage}
                    confirmMessage={getPopupInformation()[dialogType].confirmMessage}
                    popUpDialogmessage={
                      getPopupInformation(deleteProperty.name)[dialogType]
                        .popUpDialogmessage
                    }
                    popUpDialogOpen={isDialogOpen}
                    saveDialog={getPopupInformation()[dialogType].saveDialog}
                    canceleDialog={getPopupInformation()[dialogType].canceleDialog}
                    discardDialog={getPopupInformation()[dialogType].discardDialog}
                  />
                )}
                {this.state.saveProjectDialog &&
                  <SaveProjectDialog
                    regions={getoffices}
                    SaveProjectDialogOpen={this.state.saveProjectDialog}
                    handleDialog={this.handleSaveProjectDialog}
                  />
                }
                {this.state.selectSourceDialog &&
                  <SelectSourceForUnitMixDialog
                    unitMixSources={this.state.unitMixSources}
                    SelectSourceDialogOpen={this.state.selectSourceDialog}
                    handleSourceDialog={this.handleSourceDialog}
                    propertySearchData={this.props.propertySearchData}
                    isPropertyExists={this.state.isPropertyExists}
                  />
                }
              </div>
            }
            <Snackbar
              data-testid="snackbar-property-img-deleted"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              className="snackbar"
              open={this.state.snackbarFlag}
              onClose={this.handleCloseSnackbar}
              autoHideDuration={5000}
              message={getSnackBarMessage()}
            />
          </React.Fragment>
        </Loading>
        <Backdrop
          data-testid="backdrop-loader"
          className="backdrop"
          open={downloading}
        >
          <h2 className="backdrop-text">Downloading PDF...</h2>
        </Backdrop>
        <Backdrop
          data-testid="backdrop-loader-saving"
          className="backdrop"
          open={saving}
        >
          <h2 className="backdrop-text">Saving COMPS Project...</h2>
        </Backdrop>
        <Backdrop
          data-testid="backdrop-loader-updating"
          className="backdrop"
          open={updating}
        >
          <h2 className="backdrop-text">Updating COMPS Project...</h2>
        </Backdrop>
        <Backdrop
          data-testid="backdrop-loader-listRefresh"
          className="backdrop"
          open={listRefresh}
        >
          <h2 className="backdrop-text">Refreshing COMPS Project...</h2>
        </Backdrop>
      </React.Fragment>
    )
  }
}

Preview.propTypes = {
  editFeature: PropTypes.func,
  setComps: PropTypes.func,
  resetComps: PropTypes.func,
  reArrangeComps: PropTypes.func,
  propertyInfo: PropTypes.array,
  projectName: PropTypes.string,
  resetflag: PropTypes.bool,
  templateName: PropTypes.string,
  downloadPdf: PropTypes.func,
  downloadPdfWithBaseString: PropTypes.func,
  clearComps: PropTypes.func,
  getProject: PropTypes.func,
  barChartSettings: PropTypes.shape({
    isFloorPlan: PropTypes.bool,
    isSummaryBarCharts: PropTypes.bool
  }),
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasAmenities: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    hasUnitMix: PropTypes.bool
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      propertyInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      projectName: PropTypes.string
    })
  }),
  deleteProperty: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.object,
    action: PropTypes.string
  }),
  loading: PropTypes.bool,
  downloading: PropTypes.bool,
  saving: PropTypes.bool,
  updating: PropTypes.bool,
  listRefresh: PropTypes.bool,
  barChartData: PropTypes.array,
  fpBarChartData: PropTypes.array,
  fpSummaryData: PropTypes.array,
  isDialogOpen: PropTypes.bool,
  dialogType: PropTypes.string,
  isPopupDialogOpen: PropTypes.func,
  match: PropTypes.object,
  saveCompsProject: PropTypes.func,
  updateCompsProject: PropTypes.func,
  getoffices: PropTypes.array,
  getCompsOffices: PropTypes.func,
  selectedProjectId: PropTypes.string,
  status: PropTypes.string,
  donutChartThemeColors: PropTypes.object,
  getProperties: PropTypes.func,
  getPropertyInfo: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  propertySearchData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  getPropertyInfoBySource: PropTypes.func,
  refreshListInfo: PropTypes.func,
  isListRefreshed: PropTypes.bool
}

const mapStateToProps = state => ({
  barChartSettings: Comps.selectors.comps.barChartSettings(state),
  toggleSettings: Comps.selectors.comps.toggleSettings(state),
  downloading: Comps.selectors.network.isLoading(
    state,
    Comps.constants.DOWNLOAD_PDF_S3.ACTION
  ),
  saving: Comps.selectors.network.isLoading(
    state,
    Comps.constants.SAVE_COMPS_PROJECT.ACTION
  ),
  updating: Comps.selectors.network.isLoading(
    state,
    Comps.constants.UPDATE_COMPS_PROJECT.ACTION
  ),
  loading: Comps.selectors.network.isLoading(
    state,
    Comps.constants.GET_PROJECT_BY_ID.ACTION
  ),
  listRefresh: Comps.selectors.network.isLoading(
    state,
    Comps.constants.REFRESH_LIST_INFO.ACTION
  ),
  propertyInfo: Comps.selectors.comps.compsData(state),
  templateName: Comps.selectors.comps.templateName(state),
  projectName: Comps.selectors.comps.projectName(state),
  resetflag: Comps.selectors.comps.resetflag(state),
  barChartData: Comps.selectors.comps.barChartData(state),
  fpSummaryData: Comps.selectors.comps.fpSummaryData(state),
  fpBarChartData: Comps.selectors.comps.fpBarChartData(state),
  isDialogOpen: Comps.selectors.comps.isDialogOpen(state),
  dialogType: Comps.selectors.comps.dialogType(state),
  getoffices: Comps.selectors.comps.getOffices(state),
  status: Comps.selectors.comps.status(state),
  selectedProjectId: Comps.selectors.comps.selectedProjectId(state),
  donutChartThemeColors: Comps.selectors.comps.donutChartThemeColors(state),
  data: Property.selectors.property.data(state),
  propertySearchData: Comps.selectors.comps.propertySearchData(state),
  isListRefreshed: Comps.selectors.comps.isListRefreshed(state)
})
const mapDispatchToProps = {
  resetComps: Comps.actions.resetComps,
  clearComps: Comps.actions.clearComps,
  deleteProperty: Comps.actions.deleteProperty,
  reArrangeComps: Comps.actions.reArrangeComps,
  downloadPdf: Comps.actions.downloadPdf,
  editFeature: Comps.actions.editFeature,
  isPopupDialogOpen: Comps.actions.isPopupDialogOpen,
  getProject: Comps.actions.getProjectById,
  getCompsOffices: Comps.actions.getCompsOffices,
  saveCompsProject: Comps.actions.saveCompsProject,
  updateCompsProject: Comps.actions.updateCompsProject,
  getProperties: Property.actions.getProperties,
  getPropertyInfo: Comps.actions.getPropertyInfo,
  getPropertyInfoBySource: Comps.actions.getPropertyInfoBySource,
  refreshListInfo: Comps.actions.refreshListInfo
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview)
